export  const MessageConstant = {
   SELECTCROP:"Please select crop",
   SPLOTREQ:"Please enter number of SpLots",
   FRUITCOUNTREQ:"Fruit count is required",
   BAGSREQ: "Bags count is required",
   WEIGHTREQ: "Weight  is required",
   VALUECANNTNEGATIVE:"Value cannot be negative.",
   SPLOTFILTERNAME:"Please provide Filter name",
   SELECTSTATUS:"Please select status",
   SELECTSITE:"Please select site",
   SELECTPRIORITY:"Please select priority",
   MATIDPROVIDE:"Material ID is required",
   SPLOTIDREQ:"Please enter SpLots ID",
   SELECTUPDATEONDATE:"Plese select proper date",
   REMARKREQ:"Please select remark", 
   NOPERMISSION:"You do not have permission to view this screen. Please contact the administrator.",
   USERPERMISSIONUPDATEFAILED:"Could not update access due to technical issues. If issue persists contact administrator"  
}
